module.exports = __webpack_public_path__ + "img/static-texas3@2x.96698813.png";